import React, { ChangeEvent, useState } from 'react';
import styled from '@emotion/styled';
import { useI18n } from '~Hooks';

const ManualInputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
`;

const FormatInput = styled.input`
  border-radius: 4px;
  border: 1px solid #c3c5c7;
  height: 64px;
  background-color: #fff;
  width: 100%;
  max-width: 360px;
  box-sizing: border-box;
  padding: 16px;
  font-size: 32px;
  font-weight: 500;
  color: #1c232c;
  margin: 0 8px 0 0;
  padding: 0 20px;

  &:focus {
    border-color: #1c232c;
    outline: none;
  }
`;

const ManualInputConfirmButton = styled.div`
  padding: 10px;
  font-size: 32px;
  color: #fff;
  background: linear-gradient(-180deg, rgb(32, 153, 70) 0%, rgb(23, 132, 69) 100%);
  border-radius: 4px;
  width: auto;
  line-height: 1.4;
`;

interface Props {
  submit: (s: string) => void;
  format?: string;
}

export const ManualView = ({ submit, format = '#### #### #### ####' }: Props) => {
  const { i18n } = useI18n();

  const [manualCardNumber, setManualCardNumber] = useState<string>('');

  // replace all # with * for placeholder
  const placeholder = format.replace(/#/g, '*');

  // remove spaces from card number
  const cardNumber = manualCardNumber.replace(/ /g, '');

  return (
    <ManualInputWrapper>
      <FormatInput
        value={manualCardNumber}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          setManualCardNumber(e.target.value.replace(/-/g, '').toUpperCase());
        }}
        type="text"
        placeholder={placeholder}
      />
      <ManualInputConfirmButton
        onClick={() => {
          submit(cardNumber);
        }}>
        {i18n('GC.OK')}
      </ManualInputConfirmButton>
    </ManualInputWrapper>
  );
};
